"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _react = require("react");

var _lodash = require("lodash");

var memoizeFormElement = function memoizeFormElement(Element) {
  var additionalComparisonProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  if (!Array.isArray(additionalComparisonProps)) throw new Error('additionalComparisonProps param must be an array');
  return /*#__PURE__*/(0, _react.memo)(Element, function (prevProps, nextProps) {
    var comparisonPropsForRerender = ['value', 'submitAttempted', 'validations'].concat((0, _toConsumableArray2["default"])(additionalComparisonProps)); // if props are equal, do not rerender

    var arePropsEqual = true;
    comparisonPropsForRerender.forEach(function (key) {
      if (!(0, _lodash.isEqual)(prevProps[key], nextProps[key])) {
        // if props are not equal, component should rerender
        arePropsEqual = false;
      }
    });
    return arePropsEqual;
  });
};

var _default = memoizeFormElement;
exports["default"] = _default;